<template>
  <v-container fluid grid-list-xl fill-height>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'confirm',
  data() {
    return {
      apiUrl: window.api_url,
    };
  },
  mounted() {
    this.confirmAccount();
  },
  methods: {
    confirmAccount() {
      const vm = this;

      axios.post(`${this.apiUrl}api/register/confirm`, {
        confirmation_code: this.$route.params.confirmationCode,
      })
        .then((response) => {
          vm.$toasted.show(response.data.message, { duration: 3000, singleton: true, type: 'success' });
          vm.$router.push('/');
        })
        .catch((error) => {
          vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
          vm.$router.push('/');
        });
    },
  },
};
</script>

<style scoped>

</style>
